import { Link, usePage } from "@inertiajs/react";

export default function ContactLink({ topic, children, ...props }) {
  const { routes } = usePage().props;
  return <Link href={topic === "privacy" ? `${routes.contact}?topic=privacy` : routes.contact} {...props}>{children}</Link>;
}
